import { useEffect } from 'react';
var useMount = function (callback, deps) {
    if (deps === void 0) { deps = []; }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(callback, deps);
};
export default useMount;
